import React, { Component } from 'react';
import type { Store } from 'redux';
import { batchActions } from 'redux-batched-actions';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import isShallowEqual from '@atlassian/jira-common-util-is-shallow-equal/src/index.tsx';
import type { VersionId } from '../common/model/index.tsx';
import type { Handlers } from './model/index.tsx';
import rootEpic from './ops/index.tsx';
import {
	initialRequest,
	setContext,
	setHandlers,
	setCreateReleaseNotesOptionConfig,
} from './state/actions.tsx';
import createStore from './state/index.tsx';
import type { State } from './state/types.tsx';
import View from './view/index.tsx';

export type DispatchProps = Handlers;
export type StateProps = {
	readonly baseUrl: string;
	readonly projectKey: string;
	readonly versionId: VersionId;
	readonly shouldShowCreateReleaseNotesOption?: boolean;
	readonly hasReleaseNote?: boolean;
};

export type Props = StateProps & DispatchProps;

// eslint-disable-next-line jira/react/no-class-components
export default class ReleaseVersionApp extends Component<Props> {
	constructor(props: Props) {
		super(props);
		this.store = createStore(rootEpic);
		this.setAppProps(this.props);
		this.store.dispatch(initialRequest(this.props.versionId));
	}

	UNSAFE_componentWillReceiveProps(nextProps: Props) {
		if (isShallowEqual(nextProps, this.props)) {
			return;
		}
		this.setAppProps(this.props);
	}

	setAppProps(props: Props) {
		const {
			baseUrl,
			projectKey,
			onOpened,
			onError,
			onSuccess,
			onCancel,
			shouldShowCreateReleaseNotesOption = false,
			hasReleaseNote = false,
		} = props;
		this.store.dispatch(
			batchActions([
				setContext({ baseUrl, projectKey }),
				setHandlers({
					onOpened,
					onError,
					onSuccess,
					onCancel,
				}),
				setCreateReleaseNotesOptionConfig({
					shouldShowCreateReleaseNotesOption,
					hasReleaseNote,
				}),
			]),
		);
	}

	store: Store<State>;

	render() {
		return (
			<AppBase store={this.store} id="versionReleaseModal">
				<View />
			</AppBase>
		);
	}
}
